import { ModuleWithProviders, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HTTP_INTERCEPTORS, HttpClientJsonpModule } from '@angular/common/http';
import { FlexLayoutModule } from '@angular/flex-layout';
import { NgxImgModule } from 'ngx-img';
import { TranslateModule } from '@ngx-translate/core';
import { ChartsModule } from 'ng2-charts';

import { MaterialFeatureModule } from '@app/shared/modules/material-feature.module';
import { FormFeatureModule } from '@app/shared/modules/form-feature/form-feature.module';

import {
  AcronymComponent,
  AutocompleteComponent,
  AvatarComponent,
  ButtonComponent,
  CardComponent,
  CardListComponent,
  ChartComponent,
  ChipsComponent,
  DataTableCardComponent,
  DataTableComponent,
  DropdownComponent,
  FabComponent,
  FooterComponent,
  FullRowSectionComponent,
  ImgUploaderComponent,
  LoadingSpinnerComponent,
  MainSidenavComponent,
  MaterialBodyComponent,
  MaterialComponent,
  MaterialFooterComponent,
  MaterialHeaderComponent,
  MaterialTabComponent,
  MaterialTabsComponent,
  MessageDialogComponent,
  NoDataComponent,
  SearchComponent,
  SidenavComponent,
  SidePanelComponent,
  SuccessSpinnerComponent,
  TextboxComponent,
  ToolbarComponent,
  VirtualScrollerComponent
} from '@app/shared/components';
import { Error404Component } from '@app/shared/containers/error404/error404.component';

import { AuthorizationHeaderInterceptor } from '@app/shared/interceptors/auth-header.interceptor';
import { ErrorHandlingInterceptor } from '@app/shared/interceptors/error-handling.interceptor';

import { DisplayFieldComponent } from '@components/display-field/display-field.component';
import { TwoWaySliderComponent } from '@components/two-way-slider/two-way-slider.component';
import { BulletStepComponent } from '@components/bullet-step/bullet-step.component';
import { NouisliderModule } from 'ng2-nouislider';
import { ImageCarouselSliderComponent } from '@components/image-carousel-slider/image-carousel-slider.component';
import { MenuProgressStepperComponent } from '@components/menu-progress-stepper/menu-progress-stepper.component';
import { ImageSliderComponent } from '@components/image-slider/image-slider.component';
import { FiltersAccordionComponent } from '@components/filters-accordion/filters-accordion.component';
import { CalendarComponent } from './calendar/calendar.component';
import { CellComponent } from './cell/cell.component';
import { BackArrowComponent } from '@components/back-arrow/back-arrow.component';
import { FormAutocompleteComponent } from '@components/form-autocomplete/form-autocomplete.component';

@NgModule({
  declarations: [
    // Containers
    Error404Component,

    // Components
    ButtonComponent,
    BackArrowComponent,
    MainSidenavComponent,
    FooterComponent,
    ToolbarComponent,
    SidenavComponent,
    AvatarComponent,
    SidePanelComponent,
    AutocompleteComponent,
    ImgUploaderComponent,
    SearchComponent,
    MessageDialogComponent,
    DataTableComponent,
    FabComponent,
    ChipsComponent,
    LoadingSpinnerComponent,
    BulletStepComponent,
    DropdownComponent,
    ChipsComponent,
    FabComponent,
    FullRowSectionComponent,
    TextboxComponent,
    AcronymComponent,

    MaterialComponent,
    MaterialTabsComponent,
    MaterialTabComponent,
    MaterialHeaderComponent,
    MaterialBodyComponent,
    MaterialFooterComponent,
    NoDataComponent,
    BulletStepComponent,
    VirtualScrollerComponent,

    NoDataComponent,

    MenuProgressStepperComponent,
    CardComponent,
    CardListComponent,
    DataTableCardComponent,
    DisplayFieldComponent,
    SuccessSpinnerComponent,
    LoadingSpinnerComponent,
    TwoWaySliderComponent,
    BulletStepComponent,
    ImageCarouselSliderComponent,
    FiltersAccordionComponent,
    ImageSliderComponent,
    CalendarComponent,
    CellComponent,
    ChartComponent,
    FormAutocompleteComponent
  ],
  imports: [
    // Modules
    CommonModule,
    RouterModule,
    HttpClientJsonpModule,
    FormsModule,
    ReactiveFormsModule,
    FlexLayoutModule,
    NgxImgModule,
    TranslateModule.forChild(),
    ChartsModule,

    // Feature modules
    MaterialFeatureModule,
    FormFeatureModule,
    NouisliderModule,
  ],
  exports: [
    // Modules
    CommonModule,
    RouterModule,
    HttpClientJsonpModule,
    FormsModule,
    ReactiveFormsModule,
    FlexLayoutModule,
    NgxImgModule,
    TranslateModule,
    ChartsModule,

    // Feature modules
    MaterialFeatureModule,
    FormFeatureModule,

    // Containers
    Error404Component,

    // Components
    ButtonComponent,
    MainSidenavComponent,
    FooterComponent,
    ToolbarComponent,
    SidenavComponent,
    AvatarComponent,
    SidePanelComponent,
    AutocompleteComponent,
    ImgUploaderComponent,
    SearchComponent,
    MessageDialogComponent,
    DataTableComponent,
    DropdownComponent,
    ChipsComponent,
    FabComponent,
    FullRowSectionComponent,
    TextboxComponent,
    FabComponent,
    ChipsComponent,
    LoadingSpinnerComponent,
    AcronymComponent,

    MaterialComponent,
    MaterialTabsComponent,
    MaterialTabComponent,
    MaterialHeaderComponent,
    MaterialBodyComponent,
    MaterialFooterComponent,
    NoDataComponent,
    BulletStepComponent,
    VirtualScrollerComponent,

    CardComponent,
    CardListComponent,
    DataTableCardComponent,
    DisplayFieldComponent,
    SuccessSpinnerComponent,
    LoadingSpinnerComponent,
    VirtualScrollerComponent,
    TwoWaySliderComponent,
    BulletStepComponent,
    ImageCarouselSliderComponent,
    FiltersAccordionComponent,
    ImageSliderComponent,
    MenuProgressStepperComponent,
    BackArrowComponent,
    CalendarComponent,
    ChartComponent,
    FormAutocompleteComponent

  ]
})
export class SharedModule {
  static forRoot(): ModuleWithProviders<SharedModule> {
    return {
      ngModule: SharedModule,
      providers: [
        {
          provide: HTTP_INTERCEPTORS,
          useClass: AuthorizationHeaderInterceptor,
          multi: true
        },
        {
          provide: HTTP_INTERCEPTORS,
          useClass: ErrorHandlingInterceptor,
          multi: true
        }
      ]
    };
  }
}
